<div class="p-4 print:hidden fade-slide-in space-y-4">
  <div>
    <app-selection-header/>
  </div>

  @if (selectionStore.snapshot()) {
    <div>
      @if (selectionStore.snapshot()) {
        <app-selection-items/>
      }
    </div>

    <div>
      <app-selection-footer (onsubmit)="submit($event)"/>
    </div>
  } @else {
    @if (selectionStore.snapshotError(); as error) {
      <app-alert variant="error">{{error}}</app-alert>
    }
  }
</div>
